import {
  Component,
  Input }                           from '@angular/core';
import { NgForm }           from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { CompanyService }           from '../companies/company.service';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { HaynesProService }         from './haynes-pro.service';
import { MessagesService }          from '../messages/messages.service';

@Component({
  selector   : 'wor-haynes-pro-subscription-settings',
  template: require('./haynes-pro.subscription.settings.component.html')
})
export class HaynesProSubscriptionSettingsComponent {

  @Input() settings : CompanyIntegrationsModel;

  constructor (
    public companyService  : CompanyService,
    public haynesProService: HaynesProService,
    private messagesService: MessagesService,
    private router         : UIRouter,
    public translateService: TranslateService
  ) {}

  activate () : void {
    this.haynesProService.activateSubscription()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.haynesProService.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }

  deactivate () : void {
    this.haynesProService.deactivateSubscription()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.REMOVED_INTEGRATION', {
        name: this.haynesProService.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }

  save ( form : NgForm ) : void {
    this.haynesProService.saveSubscriptionSettings(this.settings)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      this.router.stateService.reload();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }
}
